export enum ActionType {
    TEST = "Test",
    SNACKBAR_TYPE="SNACKBAR_TYPE"
}